"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertHexToRGBValues = exports.convertHexToRGB = void 0;
var convertHexToRGB = function (hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    }
    return "rgb(" + r + ", " + g + ", " + b + ")";
};
exports.convertHexToRGB = convertHexToRGB;
var convertHexToRGBValues = function (hex) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    return r + ", " + g + ", " + b;
};
exports.convertHexToRGBValues = convertHexToRGBValues;
//# sourceMappingURL=hexToRGB.js.map